import { Mcb2Pole } from './mcb-2-pole';

export class Rcbo2Pole extends Mcb2Pole {
  _availableSize = [16, 20, 25, 32, 40, 50, 63, 80, 100];

  isOverCurrentProtection = true;
  _name = 'RCBO 2P';
}
